import { GetSubmitList } from '@/service/ticket'
const {
    VUE_APP_TICKET_QUESTION_PROCESS,
    VUE_APP_TICKET_SERVICE_ID,
    VUE_APP_FORM,
    VUE_APP_FORM_SERVICE_ID
} = window.env
const form = VUE_APP_FORM + VUE_APP_FORM_SERVICE_ID
const statusIds = VUE_APP_TICKET_QUESTION_PROCESS
const projectId = VUE_APP_TICKET_SERVICE_ID
export default {
    methods: {
        async createNew() {
            try {
                const { total } = await GetSubmitList({
                    statusIds,
                    projectId,
                    index: 1,
                    size: 1
                })
                if (total >= 1) {
                    await this.$confirm({
                        title: '创建新会话',
                        message: `我们的客服人员可以解答所有问题噢！ 您还有会话还没结束，是否开启一个新的会话？`,
                        confirmButtonText: '开启',
                        cancelButtonText: '去会话列表'
                    })
                }
                window.location.href = form
            } catch {
                if (this.$route.name !== 'customerService') {
                    this.$router.push({ name: 'customerService' })
                }
            }
        }
    }
}
